export default __webpack_public_path__ + "static/media/wisr-option-img.2228ed99.png";